import { z } from "zod";

export const AccountSettingSchema = z.object({
  firstname: z.string(),
  lastname: z.string(),
  phone: z.string(),
  country: z.string(),
  state: z.string(),
  city: z.string(),
  occupation: z.string(),
  occupationId: z.number(),
});

export type AccountSettingSchemaType = z.infer<typeof AccountSettingSchema>;

export type AccountFormFieldKey = keyof AccountSettingSchemaType;
